import React, { FunctionComponent, ReactNode } from 'react';
import styled, { StyledComponent, css } from 'styled-components';
import { Colors, Theme } from '@inplayer-org/inplayer-ui';
import { ifProp } from 'styled-tools';

// styled components
import { BlueTypography } from './SharedStyledElements';

interface ItemContainer {
  cursorPointer?: boolean;
  displayTransition?: boolean;
  segmentationDescription?: boolean;
}

const ItemContainer: StyledComponent<'div', Theme, ItemContainer> = styled.div`
  width: 100%;
  height: 100%;
  padding: 1rem;
  overflow: visible;
  align-items: flex-start;
  justify-content: ${ifProp('segmentationDescription', 'flex-start', 'space-between')};
  display: flex;
  flex-direction: column;
  cursor: ${ifProp('cursorPointer', 'pointer', 'auto')};
  background: ${Colors.white};

  ${({ displayTransition }: ItemContainer) =>
    displayTransition &&
    css`
      transition: all 200ms ease-in-out;

      &:hover {
        transform: scale(1.03);
        box-shadow: #d7dde5 0px 0.2rem 0.5rem;
      }
    `};

  ${({ segmentationDescription }: HeaderContainerProps) =>
    segmentationDescription &&
    css`
      padding: 1rem 1.5rem;
    `}
`;

interface HeaderContainerProps {
  segmentationDescription?: boolean;
}

const HeaderContainer: StyledComponent<'div', Theme, HeaderContainerProps> = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  ${({ segmentationDescription }: HeaderContainerProps) =>
    segmentationDescription &&
    css`
      padding-top: 0.5rem;
      height: 3rem;
    `}
`;

interface Props {
  boxItem: any;
  cursorPointer?: boolean;
  displayTransition?: boolean;
  renderActionMenu?: () => void;
  children: ReactNode;
}

const BoxItemContent: FunctionComponent<Props> = ({
  boxItem: { name, description },
  cursorPointer,
  displayTransition,
  renderActionMenu,
  children,
}: Props) => {
  return (
    <ItemContainer
      cursorPointer={cursorPointer}
      displayTransition={displayTransition}
      segmentationDescription={description}
    >
      <HeaderContainer segmentationDescription={description}>
        <BlueTypography variant="h5">{name}</BlueTypography>
        {renderActionMenu && renderActionMenu()}
      </HeaderContainer>
      <div>{children}</div>
    </ItemContainer>
  );
};

export default BoxItemContent;
